import React, { useCallback, useEffect, useRef, useState } from 'react';
import './NavigationMenu.scss';
import PerfectScrollbar from 'react-perfect-scrollbar';
import classNames from 'classnames';
import { isNil, map } from 'lodash-es';
import { useParams } from 'react-router-dom';
import { useModal } from '../../providers/ModalProvider/ModalProvider';
import { UpsertCategory } from '../Category/UpsertCategory/UpsertCategory';
import { useGetMenuByIdQuery } from '../../store/menu/menuApi';

export interface INavigationMenuProps {
	onCategoryChange: (categoryId: string) => void;
}

export const NavigationMenu = ({ onCategoryChange }: INavigationMenuProps): JSX.Element => {
	const { menuId } = useParams<{ menuId?: string }>();
	const { data: menu } = useGetMenuByIdQuery(menuId, { skip: isNil(menuId) });
	const { categories = [] } = menu ?? { categories: [] };
	const [activeIndex, setActiveIndex] = useState(categories?.length > 4 ? 3 : 0);
	const [selectedItemData, setSelectedItemData] = useState<{ offsetLeft: number; width: number }>(null);
	const navigationMenuRef = useRef(null);
	const { openModal } = useModal();

	useEffect(() => {
		if (!isNil(categories) && categories.length > 0) {
			const item = document.getElementsByClassName('navigationMenuItem')[activeIndex] as HTMLElement;

			setSelectedItemData({ offsetLeft: item.offsetLeft, width: item.offsetWidth });
		}
	}, [activeIndex, categories]);

	const handleItemClick = (index: number, id: string): void => {
		setActiveIndex(index);
		onCategoryChange(id);
	};

	const getIndicatorPosition = useCallback((): string => {
		if (!selectedItemData) {
			return '50%';
		}

		return `${selectedItemData.offsetLeft + selectedItemData.width / 2 - 27.5}px`;
	}, [selectedItemData]);

	const handleCreateCategoryClick = (): void => {
		const closeModal = openModal(
			<UpsertCategory
				onSubmit={(): void => {
					closeModal();
				}}
				onCancel={(): void => {
					closeModal();
				}}
				menuId={menuId}
			/>
		);
	};

	return (
		<PerfectScrollbar className="navigationMenuScroller">
			<div className="navigationMenuContainer" ref={navigationMenuRef}>
				{map(categories, (category, index) => (
					<div key={category.id} className={classNames('categoryNavigationItemContainer', { active: index === activeIndex })}>
						<div
							className={classNames('navigationMenuItem', { active: index === activeIndex })}
							onClick={(): void => handleItemClick(index, category.id)}
						>
							{category.title}
						</div>
					</div>
				))}
				<div className="addCategory" onClick={handleCreateCategoryClick}>
					{!categories?.length && <>הוסף קטגוריה</>} +
				</div>
				{selectedItemData && (
					<div
						className="indicator"
						style={{
							left: getIndicatorPosition(),
						}}
					>
						<img src="/images/indicator.png" alt="" />
					</div>
				)}
			</div>
		</PerfectScrollbar>
	);
};
